module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/21.20290889.jpg";